module.exports = __webpack_public_path__ + "img/TSGBrauchwasser.c31f2ad6.png";